import { useMediaQuery } from "react-responsive";

const useIsMobile = () => {
  return !useMediaQuery({
    query: "(min-width: 835px)",
  });
};

export default useIsMobile;
